import { fetchCsvListAPI } from '../../api/fetch-functions/csv';
import { ICsvType } from '../../types/record/csv';
import {
  fetchListFnGenerator,
  fetchSignalStreamGenerator,
  listStreamGenerator
} from './common/zero-id-list';

const fetchSignal$ = fetchSignalStreamGenerator();

/**
 * @description
 * `fetchCsvList()`を実行すると`csvList$`が発火する．
 */
export const fetchCsvList = fetchListFnGenerator(fetchSignal$);

export const csvList$ = listStreamGenerator<ICsvType>(
  fetchSignal$,
  fetchCsvListAPI
);
